import React from 'react'
import { Link } from '@elements'

export const RoleCards = ({ roleCards }) => {
  return (
    <section className="py-20 bg-gray-200">
      <div className="container">
        <div className="flex flex-wrap break-words md:-mx-4 md:justify-center">
          {roleCards.map((card, idx) => (
            <div
              key={idx}
              className="w-full mx-auto mt-8 lg xl:w-1/2 md:px-4 xl:px-8 xl:pb-12"
            >
              <div className="w-full p-10 leading-tight text-gray-400 bg-white shadow-md xl:p-16 xl:h-full">
                <h2 className="font-sans text-4xl font-bold tracking-wider text-black uppercase sm:text-5xl">
                  {card.roleTitle}
                </h2>
                <div
                  className="mt-4 leading normal prose prose-xl"
                  dangerouslySetInnerHTML={{ __html: card.roleContent }}
                ></div>
                {/* className="mt-2 text-lg leading-normal sm:mt-4 sm:text-2xl sm:leading-snug" */}
                {card.callToActionGroup.ctaLinkUrl && (
                  <Link
                    to={card.callToActionGroup.ctaLinkUrl}
                    className={
                      card.callToActionGroup.ctaButtonType === `primary`
                        ? `inline-block mt-12 px-10 pt-1 font-sans text-2xl font-bold text-gray-400 no-underline uppercase transition duration-200 border-6 border-brand-yellow hover:bg-brand-yellow`
                        : card.callToActionGroup.ctaButtonType === `text`
                        ? `inline-block mt-12 ml-2 font-sans text-xl font-bold tracking-wide text-gray-400 no-underline uppercase transition duration-200 border-b-4 border-gray-400 sm:mt-16 sm:border-b-6 hover:border-brand-yellow sm:text-2xl`
                        : ``
                    }
                  >
                    {card.callToActionGroup.ctaLinkText}
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
